// action - state management
import { createSlice } from "@reduxjs/toolkit";

// ==============================|| ACCOUNT REDUCER ||============================== //


const initialState: any = {
    loading: false,
    subscriptions: {
        rows: [],
        order: "asc",
        orderBy: "",
        limit: 50,
        search: "",
        count: 0,
        offset: 0,
    },
    record: {
        rows: [],
        order: "asc",
        orderBy: "",
        limit: 50,
        search: "",
        select: '',
        count: 0,
        offset: 0,
    },
    fields: {},
    subscriptionToDelete: null,
};

const ReducerSlice = createSlice({
    name: "subscription",
    initialState: initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload || false;
        },
        setSubscriptions(state, action) {
            if (action.payload.subscription) {
                state.subscriptions.rows = action.payload.subscription.map((x: any, index: number) => {

                    let y = { ...x };
                    if (index > 0 && action.payload.subscription[index - 1].slug === x.slug) {

                        y.hasDuplicate = true;
                    }
                    return y;
                });
            }
            if (
                action.payload.subscription_aggregate &&
                action.payload.subscription_aggregate.aggregate
            ) {
                state.subscriptions.count = action.payload.subscription_aggregate.aggregate.totalCount;
            }
            if (
                action.payload.offset !== undefined &&
                action.payload.offset !== null
            ) {
                state.subscriptions.offset = action.payload.offset;
            }
            if (action.payload.limit !== undefined && action.payload.limit !== null) {
                state.subscriptions.limit = action.payload.limit;
            }
            if (
                action.payload.search !== undefined &&
                action.payload.search !== null
            ) {
                state.subscriptions.search = action.payload.search;
            }
            if (
                action.payload.is_deleted !== undefined &&
                action.payload.is_deleted !== null
            ) {
                state.subscriptions.is_deleted = action.payload.is_deleted;
            }
        },
        setSubscriptionToDelete(state, action) {
            state.subscriptionToDelete = action.payload;
        },
        deleteSubscription(state) {
            state.subscriptions.rows = state.subscriptions.rows.filter(
                (subscription: any) => subscription.id !== state.subscriptionToDelete.id
            );
        },
        setFields(state, action) {
            const { id, fields } = action.payload;
            state.fields[id] = fields;
        },
        clearDeletedBlockIds(state) {
            state.blockIdsToDelete = [];
        },
        setRecords(state, action) {
            if (action.payload.record) {
                state.record.rows = action.payload.record;
              }
            if (
                action.payload.record_aggregate &&
                action.payload.record_aggregate.aggregate
            ) {
                state.record.count = action.payload.record_aggregate.aggregate.totalCount;
            }
            if (
                action.payload.offset !== undefined &&
                action.payload.offset !== null
            ) {
                state.record.offset = action.payload.offset;
            }
            if (action.payload.limit !== undefined && action.payload.limit !== null) {
                state.record.limit = action.payload.limit;
            }
            if (
                action.payload.is_deleted !== undefined &&
                action.payload.is_deleted !== null
            ) {
                state.record.is_deleted = action.payload.is_deleted;
            }
            if (
                action.payload.select !== undefined &&
                action.payload.select !== null
            ) {
                state.record.select = action.payload.select;
            }
            if (
                action.payload.search !== undefined &&
                action.payload.search !== null
            ) {
                state.record.search = action.payload.search;
            }
        },
    },
});

export const {
    setLoading,
    setSubscriptions,
    setSubscriptionToDelete,
    deleteSubscription,
    setFields,
    clearDeletedBlockIds,
    setRecords
} = ReducerSlice.actions;
export default ReducerSlice.reducer;
